const MAX_DECIMALS = 2;

function clampDecimals(value: string): string {
  const [whole = '', fraction = ''] = value.split('.');
  if (value.includes('.')) {
    const safeFraction = fraction.slice(0, MAX_DECIMALS);
    return safeFraction.length > 0 ? `${whole}.${safeFraction}` : `${whole}.`;
  }
  return whole;
}

function normalizeDigits(raw: string): { value: string; hasDecimal: boolean } {
  let hasDecimal = false;
  let result = '';

  for (const char of raw) {
    const isDigit = char >= '0' && char <= '9';
    if (char === '.' && !hasDecimal) {
      hasDecimal = true;
      result += '.';
    } else if (isDigit) {
      result += char;
    }
  }

  return { value: result, hasDecimal };
}

export function sanitizeRentInput(raw: string): string {
  if (typeof raw !== 'string') {
    return '';
  }
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return '';
  }

  const { value, hasDecimal } = normalizeDigits(trimmed);
  if (value.length === 0) {
    return '';
  }

  let sanitized = clampDecimals(value);

  if (sanitized.startsWith('.')) {
    sanitized = `0${sanitized}`;
  } else if (sanitized === '.' && !hasDecimal) {
    sanitized = '';
  }

  return sanitized;
}

export function formatRentInputValue(raw: string): string {
  if (typeof raw !== 'string') {
    return '';
  }
  const trimmed = raw.trim();
  if (trimmed.length === 0 || trimmed === '.') {
    return '';
  }
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) {
    return '';
  }
  const rounded = Math.round(parsed * 100) / 100;
  return Number.isFinite(rounded) ? removeTrailingZeros(rounded.toFixed(2)) : '';
}

export function formatRentNumberToInput(value: number | null | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '';
  }
  return formatRentInputValue(value.toString());
}

function removeTrailingZeros(value: string): string {
  if (!value.includes('.')) {
    return value;
  }
  const normalized = value.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
  return normalized.endsWith('.') ? normalized.slice(0, -1) : normalized;
}
